import { render, staticRenderFns } from "./AiMatterBuilderModal.vue?vue&type=template&id=6400d525&scoped=true"
import script from "./AiMatterBuilderModal.vue?vue&type=script&lang=js"
export * from "./AiMatterBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./ai-builder/ai-builder.css?vue&type=style&index=0&id=6400d525&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400d525",
  null
  
)

export default component.exports